import { Signage } from '../../../Signage';
import {
    UNKNOWN,
    REACH_PLAYER,
    BRIGHTSIGN,
    PREVIEW_PLAYER,
    TOUCHSCREEN,
    SCREEN_SAVER,
    FIRE_OS,
    CHROME_EXTENSION,
    WEBOS,
} from '../../../Platform';

export const GlobalSignagePlatform = {
    isType(platformType: number): boolean {
        return Signage.platform.isType(platformType);
    },

    isAtLeastVersion(minVersion: string): Promise<boolean> {
        return Signage.platform.isAtLeastVersion(minVersion);
    },
};

export const GlobalPlatform = {
    UNKNOWN,
    REACH_PLAYER,
    BRIGHTSIGN,
    PREVIEW_PLAYER,
    TOUCHSCREEN,
    SCREEN_SAVER,
    FIRE_OS,
    CHROME_EXTENSION,
    WEBOS,
};
